import { Crosshair, Puzzle, Users } from "lucide-react";
import { Reveal } from "../lib/motion";
import { scrollToId } from "../lib/scroll";
import { useLang } from "../lib/i18n";
import { Kicker } from "./Shared";

const DOOR_IMG = "/images/porte-contact.webp";
const PILLAR_ICONS = [Crosshair, Puzzle, Users];

/**
 * Pont FAQ → Contact — présentation calquée sur le mockup.
 */
export const Need = () => {
  const { t } = useLang();
  const n = t.need;

  return (
    <section
      id="besoin"
      data-testid="need-section"
      className="relative overflow-hidden bg-canvas"
    >
      <div className="relative z-10 max-w-site mx-auto px-6 md:px-12 py-10 md:py-12">
        <Reveal>
          <div
            data-testid="need-card"
            className="rounded-2xl border border-copper-light/55 bg-canvas overflow-hidden"
          >
            <div className="flex flex-col md:flex-row md:items-stretch">
              {/* Porte à gauche — hauteur = hauteur de la card */}
              <div className="relative shrink-0 flex md:block items-center justify-center h-40 md:h-auto md:w-[8.75rem] lg:w-[10rem] xl:w-[11rem]">
                <img
                  src={DOOR_IMG}
                  alt=""
                  aria-hidden
                  loading="lazy"
                  decoding="async"
                  className="cywiz-bridge-door h-[85%] w-auto md:absolute md:inset-y-[8%] md:left-3 md:right-2 md:h-[84%] md:w-auto md:max-w-full object-contain mx-auto"
                  draggable={false}
                />
              </div>

              {/* Texte */}
              <div className="flex-1 min-w-0 self-center px-6 pb-6 md:py-7 md:pl-2 md:pr-5 lg:pr-7 text-center md:text-left">
                <Kicker variant="inline">{n.kicker}</Kicker>
                <h2 className="mt-2 font-display font-normal leading-snug">
                  <span className="block text-cream text-base md:text-lg lg:text-xl">
                    {n.title[0]}
                  </span>
                  <a
                    href="#contact"
                    className="mt-0.5 text-gradient text-base md:text-lg lg:text-xl text-left hover:opacity-90 transition-opacity duration-300 inline-block"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToId("#contact");
                    }}
                  >
                    {n.title[1]}
                  </a>
                </h2>
                <p className="mt-2.5 text-[12px] md:text-[13px] text-warm font-light leading-relaxed max-w-md mx-auto md:mx-0">
                  {n.text}
                </p>
              </div>

              {/* Séparateur */}
              <div
                className="hidden md:block self-stretch w-px bg-copper-light/40 shrink-0 my-6"
                aria-hidden
              />

              {/* Trois colonnes */}
              <div className="md:w-[46%] lg:w-[48%] xl:w-[50%] shrink-0 self-center grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-0 px-5 pb-7 md:py-7 md:pl-4 md:pr-5 lg:pr-7">
                {n.pillars.map((pillar, i) => {
                  const Icon = PILLAR_ICONS[i];
                  return (
                      <div
                        key={pillar.title}
                        className={`flex flex-col items-center text-center px-2 ${
                          i > 0 ? "sm:border-l sm:border-copper-light/35" : ""
                        }`}
                      >
                        <span className="inline-flex items-center justify-center w-11 h-11 md:w-12 md:h-12 rounded-full border border-copper/70 text-copper">
                          <Icon size={18} strokeWidth={1.55} aria-hidden />
                        </span>
                        <p className="mt-4 text-[12px] md:text-[13px] text-cream font-normal leading-snug">
                          {pillar.title}
                        </p>
                        <p className="mt-1.5 text-[11px] text-dim font-light leading-snug max-w-[9.5rem]">
                          {pillar.text}
                        </p>
                      </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
